/**
 * Investor starter template.
 *
 * Persona: person who tracks multiple symbols, wants business news, clock.
 * Tile mix: markets watchlist (2×2), business news (2×2), clock (1×1), weather (1×1).
 */
import { BOARD_SCHEMA_VERSION, TILE_SCHEMA_VERSION } from 'briefpane/schema';

export const INVESTOR_BOARD_RAW: unknown = {
  schemaVersion: BOARD_SCHEMA_VERSION,
  id: 'board_investor',
  createdAt: '2026-07-24T00:00:00.000Z',
  updatedAt: '2026-07-24T00:00:00.000Z',
  grid: { cols: 8, rowHeight: 120, gap: 12 },
  layout: [
    { tileId: 'tile_ivmkt1', x: 0, y: 0, w: 2, h: 2 },
    { tileId: 'tile_ivnws1', x: 2, y: 0, w: 2, h: 2 },
    { tileId: 'tile_ivclk1', x: 4, y: 0, w: 1, h: 1 },
    { tileId: 'tile_ivwx01', x: 4, y: 1, w: 1, h: 1 },
  ],
  tiles: [
    {
      v: TILE_SCHEMA_VERSION,
      id: 'tile_ivmkt1',
      type: 'markets.quote',
      source: {
        provider: 'finnhub',
        params: { symbols: ['SPY', 'AAPL', 'MSFT', 'BTC.USD'], display: 'change' },
      },
      refresh: { intervalSec: 60 },
      display: { size: '2x2', variant: 'list' },
      glance: { primary: 'price', delta: 'changePct', state: 'direction' },
      label: 'Watchlist',
    },
    {
      v: TILE_SCHEMA_VERSION,
      id: 'tile_ivnws1',
      type: 'news.headlines',
      source: { provider: 'gnews', params: { topic: 'business', count: 6 } },
      refresh: { intervalSec: 600 },
      display: { size: '2x2', variant: 'list' },
      glance: { primary: 'headline', delta: 'source', state: null },
      label: 'Business News',
    },
    {
      v: TILE_SCHEMA_VERSION,
      id: 'tile_ivclk1',
      type: 'clock.local',
      source: { provider: 'local', params: { tz: 'America/New_York', format: '12h' } },
      display: { size: '1x1', variant: 'big-number' },
      glance: { primary: 'time', delta: 'date', state: null },
      label: 'Clock',
    },
    {
      v: TILE_SCHEMA_VERSION,
      id: 'tile_ivwx01',
      type: 'weather.current',
      source: {
        provider: 'openweathermap',
        params: { lat: 40.71, lon: -74.01, units: 'imperial' },
      },
      refresh: { intervalSec: 900 },
      display: { size: '1x1', variant: 'big-number' },
      glance: { primary: 'tempF', delta: 'vsYesterdayF', state: 'condition' },
      label: 'Weather',
    },
  ],
};
